import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from '../../axios';
import TopNavbar from './TopNavbar';


function AdminLogin() {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [status, setStatus] = useState('');
    const navigate = useNavigate();

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setStatus("Logging in...");

        try {
            const res = await axios.post("/admin/login", formData);
            sessionStorage.setItem("admin_token", res.data.token);
            setStatus("Login successful!");
            navigate("/admin/bannerList");
        } catch (err) {
            setStatus("Login failed. Check credentials.");
        }
    };


    return (
        <div className="min-vh-100 d-flex flex-column">
            <TopNavbar />

            <div
                className="flex-grow-1 d-flex justify-content-center pt-5 mt-5"

            >
                <div className="login-container" >
                    <h2 className="mb-4 text-center">Admin Login</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter Admin Email"
                                className="form-control"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mb-4">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                placeholder="Enter Admin Password"
                                className="form-control"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn w-100"
                            style={{ backgroundColor: "#b08a30", color: "white" }}
                        >
                            Login
                        </button>
                    </form>
                    <p className="mt-3 text-center">{status}</p>
                </div>
            </div>
        </div>

    );
}

export default AdminLogin;
